import WCWhatView from 'text!edge/fnol/wc//views/wc-what.html';
import WCWhatCtrl from 'edge/fnol/wc/controllers/WCWhatCtrl';
import WCInjuryView from 'text!edge/fnol/wc/views/wc-injury.html';
import WCInjuryCtrl from 'edge/fnol/wc/controllers/WCInjuryCtrl';
import WCWhereView from 'text!edge/fnol/wc/views/wc-where.html';
import WCWhereCtrl from 'edge/fnol/wc/controllers/WCWhereCtrl';
import WCBaseFnolWizardCtrl from 'edge/fnol/wc/controllers/WCBaseFnolWizardCtrl';

export default function () {
    const wcBaseFnolWizard = {
        name: 'wcBaseFnolWizard',
        parent: 'baseFnolWizard',
        abstract: true,
        controller: WCBaseFnolWizardCtrl,
        template: '<div ui-view></div>',
        data: {
            trackingUrl: ''
        }
    };

    return {
        wcBaseFnolWizard: wcBaseFnolWizard,
        wcWhat: {
            name: 'wcWhat',
            parent: wcBaseFnolWizard,
            template: WCWhatView,
            controller: WCWhatCtrl
        },
        wcInjury: {
            name: 'wcInjury',
            parent: wcBaseFnolWizard,
            template: WCInjuryView,
            controller: WCInjuryCtrl
        },
        wcWhere: {
            name: 'wcWhere',
            parent: wcBaseFnolWizard,
            template: WCWhereView,
            controller: WCWhereCtrl
        }
    };
}
